module.exports = __webpack_public_path__ + "static/media/Julie Wu.9df778fd.png";